import {
  ComplaintById,
  ComplaintStatus,
  objectLists,
} from "@modules/plaintes/plaintes.model.ts";
import React from "react";

interface ReferenceProps {
  complaint: ComplaintById;
  activeIndex: number;
  isFocalMocipArchived: boolean;
}
const ReferencePending: React.FC<ReferenceProps> = ({
  complaint,
  activeIndex,
  isFocalMocipArchived,
}) => {
  const status = complaint.complaintUsers[0]?.status;
  const isHistory = activeIndex === 1;

  return (
    <>
      <div className="ml-8 grid grid-cols-1 lg:grid-cols-2">
        <div className="flex sm:flex-row flex-col">
          <div className="flex items-start sm:flex-row flex-col sm:items-end mr-5">
            <p className="text-2xl font-semibold text-black">
              Référence:&nbsp;
            </p>
            <p className="text-2xl text-light-gray">{complaint.ref}</p>
          </div>
          {status === ComplaintStatus.PENDING && isHistory && (
            <div className="flex items-center border border-solid border-[#1693F6] rounded-3xl p-1.5 w-max mt-2.5">
              <i className="pi pi-undo p-1 bg-[#1693F6] rounded-full text-white text-[10px]" />
              <span className="ml-2 text-[#1693F6] text-[10px] font-medium">
                En attente
              </span>
            </div>
          )}

          {status === ComplaintStatus.ESCALATED && isHistory && (
            <div className="flex items-center border border-solid border-[#4CAF50] rounded-3xl p-1.5 w-max">
              <i className="pi pi-undo p-1 bg-[#4CAF50] rounded-full text-white text-[10px]" />
              <span className="ml-2 text-[#4CAF50] text-[10px] font-medium">
                Escaladé
              </span>
            </div>
          )}
          {status === ComplaintStatus.RESOLVED_POSITIVE && isHistory && (
            <div className="flex items-center border border-solid border-[#4CAF50] rounded-3xl p-1.5 w-max">
              <i className="pi pi-check p-1 bg-[#4CAF50] rounded-full text-white text-[10px]" />
              <span className="ml-2 text-[#4CAF50] text-[10px] font-medium">
                Résolu positif
              </span>
            </div>
          )}
          {status === ComplaintStatus.RESOLVED_NEGATIVE && isHistory && (
            <div className="flex items-center border border-solid border-[#4CAF50] rounded-3xl p-1.5 w-max">
              <i className="pi pi-check p-1 bg-[#4CAF50] rounded-full text-white text-[10px]" />
              <span className="ml-2 text-[#4CAF50] text-[10px] font-medium">
                Résolu négatif
              </span>
            </div>
          )}
          {status === ComplaintStatus.ARCHIVED &&
            (isHistory || isFocalMocipArchived) && (
              <div className="flex items-center border border-solid border-[#4CAF50] rounded-3xl p-1.5 w-max">
                <i className="pi pi-undo p-1 bg-[#4CAF50] rounded-full text-white text-[10px]" />
                <span className="ml-2 text-[#4CAF50] text-[10px] font-medium">
                  Archivé
                </span>
              </div>
            )}
        </div>
        <div>
          {complaint.object && (
            <div className="flex items-start sm:items-end sm:flex-row flex-col">
              <p className="text-2xl font-semibold text-black">
                Objet de la plainte:&nbsp;
              </p>
              <p className="text-2xl text-light-gray">
                {objectLists.find((e) => e.code === complaint.object)?.name}
              </p>
            </div>
          )}
        </div>
      </div>
      <div className="gap-5 px-7 flex lg:flex-row flex-col w-full">
        <div className="col-span-1 lg:col-span-2 bg-gray-200 p-4 pl-5 rounded-xl w-full lg:w-1/2">
          <div className="space-y-3">
            <div className="flex">
              <p className="font-semibold">Date de plainte :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.createdAt as string}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Région :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.fokontany.municipality.district.region.name}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">District :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.fokontany.municipality.district.name}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Commune :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.fokontany.municipality.name}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Village :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.fokontany.name}
              </p>
            </div>
          </div>
        </div>
        <div className="col-span-1 lg:col-span-2 bg-gray-200 p-4 pl-5 rounded-xl w-full lg:w-1/2">
          <div className="space-y-3">
            <div className="flex">
              <p className="font-semibold">Nom du plaignant :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.fullName.length > 0
                  ? complaint.complaintInfo.fullName.split(" ")[0]
                  : "Plaignant anonyme"}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Prénom du plaignant :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.fullName.split(" ")[1]}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Numéro téléphone :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.phoneNumber}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Adresse :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.address}
              </p>
            </div>
            <div className="flex">
              <p className="font-semibold">Relation avec la victime :&nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintInfo.relationshipWithVictim}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="gap-5 px-7 flex flex-col lg:flex-row w-full">
        <div className="col-span-1 lg:col-span-2 bg-gray-200 p-4 pl-5 rounded-xl w-full lg:w-1/2">
          <div className="space-y-3">
            <div className="flex">
              <p className="font-semibold">Réceptionneur : &nbsp;</p>
              <p className="font-medium text-black">
                {complaint.complaintUsers[0].user.firstName}{" "}
                {complaint.complaintUsers[0].user.lastName}
              </p>
            </div>
          </div>
        </div>
        <div className="col-span-1 lg:col-span-2 bg-gray-200 p-4 pl-5 rounded-xl w-full lg:w-1/2">
          <div className="space-y-3">
            <div className="flex">
              <p className="font-semibold">
                Détail sur le réceptionneur : &nbsp;
              </p>
              <p className="font-medium text-black">
                {complaint.complaintUsers[0].user.profil?.name!}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferencePending;
